import { render, staticRenderFns } from "./hunt-reward.vue?vue&type=template&id=9856bc68&scoped=true&"
import script from "./hunt-reward.vue?vue&type=script&lang=js&"
export * from "./hunt-reward.vue?vue&type=script&lang=js&"
import style0 from "./hunt-reward.vue?vue&type=style&index=0&id=9856bc68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9856bc68",
  null
  
)

export default component.exports